import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./account.actions";
import { getters } from "./account.getters";
import { mutations } from "./account.mutations";
import { state } from "./account.state";
import { AccountState } from "./account.types";

const namespaced: boolean = true;

export const AccountManagementModule: Module<AccountState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
